import { Navigate, type RouteObject } from "react-router";

import { AppShell } from "./components/shell/AppShell";
import { ApiKeysPage } from "./features/api-keys/ApiKeysPage";
import { AuditPage } from "./features/audit/AuditPage";
import { LoginPage } from "./features/auth/LoginPage";
import { MfaPage } from "./features/auth/MfaPage";
import { HostsPage } from "./features/hosts/HostsPage";
import { OverviewPage } from "./features/overview/OverviewPage";
import { ProjectsPage } from "./features/projects/ProjectsPage";
import { GithubCallbackPage } from "./features/projects/GithubCallbackPage";
import { DataServicesPage } from "./features/data-services/DataServicesPage";
import { ProviderIntegrationsPage } from "./features/provider-integrations/ProviderIntegrationsPage";
import { OperationsSettingsPage } from "./features/settings/OperationsSettingsPage";
import { SecurityPage } from "./features/security/SecurityPage";
import { SetupPage } from "./features/setup/SetupPage";
import { TeamPage } from "./features/team/TeamPage";
import { PermissionRoute, ProtectedRoute } from "./lib/auth";
import { ForbiddenPage } from "./pages/ForbiddenPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { RouteErrorPage } from "./pages/RouteErrorPage";

export const routes: readonly RouteObject[] = [
  { path: "/kurulum", element: <SetupPage />, errorElement: <RouteErrorPage /> },
  { path: "/giris", element: <LoginPage />, errorElement: <RouteErrorPage /> },
  { path: "/giris/iki-adim", element: <MfaPage />, errorElement: <RouteErrorPage /> },
  {
    element: <ProtectedRoute />,
    children: [
      { path: "/", element: <Navigate replace to="/genel-bakis" /> },
      {
        element: <AppShell />,
        errorElement: <RouteErrorPage />,
        children: [
          { path: "/genel-bakis", element: <OverviewPage /> },
          { path: "/projeler", element: <ProjectsPage /> },
          { path: "/sources/github/callback", element: <GithubCallbackPage /> },
          { path: "/sunucular", element: <HostsPage /> },
          {
            element: <PermissionRoute permission="databases:read" />,
            children: [{ path: "/veritabanlari", element: <DataServicesPage /> }],
          },
          { path: "/ayarlar/guvenlik", element: <SecurityPage /> },
          { path: "/ayarlar/saglayicilar", element: <ProviderIntegrationsPage /> },
          { path: "/ayarlar/operasyon", element: <OperationsSettingsPage /> },
          { path: "/yetki-yok", element: <ForbiddenPage /> },
          {
            element: <PermissionRoute permission="team:read" />,
            children: [{ path: "/ekip", element: <TeamPage /> }],
          },
          {
            element: <PermissionRoute permission="api_keys:read" />,
            children: [{ path: "/ayarlar/api-anahtarlari", element: <ApiKeysPage /> }],
          },
          {
            element: <PermissionRoute permission="audit:read" />,
            children: [{ path: "/denetim-kaydi", element: <AuditPage /> }],
          },
          { path: "*", element: <NotFoundPage /> },
        ],
      },
    ],
  },
];
